import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";

class ImageInput extends React.Component {
    constructor(props) {
        super(props);
        props.input.value = props.input.value || "";
    }

    render() {
        return [
                <input autoFocus={this.props.autoFocus} onFocus={this.props.onFocus} key="input" type={this.props.input.id} value={this.props.input.value} disabled={this.props.input.disabled} id={this.props.input.id}
                       placeholder={this.props.input.placeholder} required={this.props.input.required} title={this.props.input.title}
                       onChange={this.props.onChange} onBlur={this.props.onBlur}/>,
                <img key="image" src={this.props.image.src} alt={this.props.image.alt}/>
        ]
    }
}

export const ImageInputGroup = WrapperInputGroup(ImageInput);

ImageInputGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/input/base/ImageInputGroup.js